/**
 * Calculate user level based on XP
 * Shared utility function used across the app
 */
export function calculateLevel(xp: number): number {
  if (xp < 100) return 1;
  if (xp < 300) return 2;
  if (xp < 600) return 3;
  if (xp < 1000) return 4;
  if (xp < 1500) return 5;
  if (xp < 2200) return 6;
  if (xp < 3000) return 7;
  if (xp < 4000) return 8;
  if (xp < 5500) return 9;
  return Math.floor(xp / 1000) + 5;
}

/**
 * Calculate XP required for next level
 */
export function getXPForNextLevel(level: number): number {
  const thresholds = [0, 100, 300, 600, 1000, 1500, 2200, 3000, 4000, 5500];
  if (level < 10) {
    return thresholds[level] || 5500;
  }
  return (level - 4) * 1000;
}

/**
 * Calculate progress to next level as percentage
 */
export function getLevelProgress(xp: number): number {
  const currentLevel = calculateLevel(xp);
  const currentThreshold = getXPForNextLevel(currentLevel - 1);
  const nextThreshold = getXPForNextLevel(currentLevel);
  const progress = ((xp - currentThreshold) / (nextThreshold - currentThreshold)) * 100;
  return Math.min(100, Math.max(0, progress));
}
